module.exports = __webpack_public_path__ + "img/berget-logo2.47f9a40f.png";